import React, { useState } from "react";
import InputField from "../Components/InputField";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../shared";
import AlertField from "../Components/AlertField";

const ResetPasswordConfirm = () => {
  const [values, setValues] = useState({
    password: "",
    re_password: "",
  });
  const navigate = useNavigate();
  const search = useLocation().search;
  const uid = new URLSearchParams(search).get("uid");
  const token = new URLSearchParams(search).get("token");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const inputs = [
    {
      id: 1,
      name: "password",
      type: "password",
      placeholder: "Enter new password",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 letter, 1 number and 1 special character!",
      label: "New Password",
      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
    {
      id: 2,
      name: "re_password",
      type: "password",
      placeholder: "Enter new password again",
      errorMessage: "Passwords don't match!",
      label: "Confirm Password",
      pattern: values.password,
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(
        `auth/password/reset/confirm/?uid=${uid}&token=${token}`,
        { new_password: values["password"] }
      );
      navigate("/login", {
        state: {
          message: "You have successfully changed your password.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Link has been invalid", "warning");
      } else {
        showAlert("Reset Failed", "warning");
      }
    }
  };

  return (
    <div>
      <AlertField alert={alert} />

      <div className="d-flex justify-content-center mt-5">
        <div className="p-5 bg-light border rounded-3 w-50">
          <h1 className="text-center pb-3">Confirm Password</h1>

          <form onSubmit={handleSubmit}>
            {inputs.map((input) => (
              <InputField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
            <section className="my-3">
              <label className="m-0">
                * Password should be atleast 8 characters.
              </label>{" "}
              <br />
              <label className="m-0">
                * Password should have atleast 1 special character.
              </label>{" "}
              <br />
              <label className="m-0">
                * Password should not be entirely numeric.
              </label>
            </section>
            <div className="text-center mt-2">
              <button className="btn btn-outline-dark m-2 py-2 px-5">
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordConfirm;
